<template>
    <v-container>
        <v-row>
            <v-img :src="require('@/assets/gifiqr-vidensdeling.jpg')"/>
        </v-row>
        <v-row>
            <v-col md="8" align="left">
                <h1>Intern vidensdeling</h1>
                <h4 class="my-5">Er det vigtigt for dig, at dine medarbejdere har let adgang til den samme viden om procedurer,
                    produktion og jeres fælles verden? Så brug gofiqr.</h4>
                <p>Med gofiqr's QR-kode placeret rundt omkring ved din virksomheds forskellige arbejdsstationer, sikrer
                    du, at alle medarbejdere har adgang til samme viden om produktionen, jeres procedurer og interne
                    forhold.</p>

                <h2>Hvordan?</h2>
                <p>Du sætter QR-koden på strategiske gode steder på din arbejdsplads; fx på lageret, i
                    produktionshallen, i mødelokalet eller i kantinen.</p>
                <p>Dine medarbejdere kan til enhver tid tilgå din information med deres QR-kodescannere på
                    telefonen.</p>
                <p>Alle typer information præsenteres nu i dit visuelle, professionelle univers, som er beskyttet mod
                    reklamer.</p>

                <h2>Brug den til:</h2>
                <p>Du ejer måske en virksomhed eller er dagligt ansvarlig for kvalitet, produktion eller intern
                    kommunikation og vidensdeling.</p>
                <p>Du oplever ofte, at der er stor forskel på, hvor meget dine medarbejdere ved om fx kvalitetskrav,
                    procedurer og maskinbetjening.</p>
                <p>Du mangler måske også én daglig nyhedskanal, hvor alle medarbejdere kan få samme viden om jeres
                    virksomhed. Både dem i hovedkontoret, i filialer og i bilerne. Dem på dag/nathold. Dem med og uden
                    computer. Og dem, der taler dansk og måske tyrkisk eller arabisk.</p>
                <p>Med gofiqr har du én løsning, der hjælper på det hele. Alle ansatte kan via deres telefoner scanne
                    dine koder på fx en maskine i produktionshallen og hurtigt få den relevante information, så
                    produktionen ikke går i stå. Og alle dine medarbejdere - også dem, der ikke sidder på kontor ved en
                    computer - kan via QR koder i fx firmabilerne få din videomorgenhilsen, nyheder om dagens gæster,
                    menuen i kantinen og andre nyheder via det gofiqr-univers, du har bygget op til dem.</p>

                <h4>gofiqr giver dig mulighederne. Du bestemmer indholdet.
                    gofiqr sørger for, at dine medarbejdere altid har din information ved hånden.</h4>

                <v-divider class="mt-5"/>

                <v-card flat>
                    <v-img :src="require('@/assets/knowledge01.jpeg')"/>
                </v-card>
                <h2>Med gofiqr giver du dine medarbejdere mulighed for at få:</h2>
                <h4>Effektive arbejdsgange</h4>
                <h4>Nemmere intern vidensdeling og sidemandsoplæring</h4>
                <h4>En nyhedsportal til fx ledelsesinformation</h4>
                <h4>Relevant information knyttet til den enkelte arbejdsstation</h4>
                <h4>Vejledninger og informationer på forskellige sprog</h4>
                <h4>Lettere og billigere produktion af al dokumentation</h4>

                <v-divider class="my-5"/>

                <v-card flat class="ma-0" link :to="{path: '/ergolet'}">
                    <h2>Hvem bruger gofiqr? Læs kundecase <b>HER</b></h2>
                </v-card>

                <v-divider class="mt-5"/>
            </v-col>
            <v-col md="4" align="left">
                <v-img :src="require('@/assets/vil-du-vide-mere.png')" max-width="300" class="mb-5"/>
                <ContactForm/>
                <TryGofiqr/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import TryGofiqr from "@/components/TryGofiqr";
    import ContactForm from "@/components/ContactForm";
    export default {
        name: "KnowledgeSharingPage",
        components: {TryGofiqr, ContactForm}
    }
</script>

<style scoped>

</style>